import React, { useState, useMemo } from 'react'

import { Button } from 'Components/shared/Button'
import Input from 'Components/shared/Input'
import { ErrorText, SuccessText } from 'Components/shared/Typography'

import { Flex } from 'lese'

import UserService from 'Services/users'

import { useInput, runOnEnter, constantToReadable } from 'Helpers'
import { useQueryParams } from 'raviger'
import { PERMISSIONS } from 'Root/../../shared/constants'
import { SelectUsingButton } from 'Components/shared/Select'
import { colors } from 'Constants'

export default () => {
  const [, setQueryParams] = useQueryParams()
  const [errorText, setErrorText] = useState()
  const [successText, setSuccessText] = useState()

  const usernameHook = useInput('')
  const firstNameHook = useInput('')
  const lastNameHook = useInput('')

  const [permissionLevel, setPermissionLevel] = useState(PERMISSIONS.MANAGER)
  const permissionLevelOptions = useMemo(() =>
    Object.entries(PERMISSIONS).map(val => ({
      text: constantToReadable(val[0]),
      value: val[1],
      color: colors.blue
    }))
  )

  const createUser = async () => {
    const user = await UserService.create({
      username: usernameHook.value,
      firstName: firstNameHook.value,
      lastName: lastNameHook.value,
      permissionLevel
    }).catch(err => setErrorText(err.message))
    if (!user) return
    setQueryParams({ id: user.id })
    usernameHook.reset()
    setSuccessText('Successfully created user')
    setErrorText()
  }

  return (
    <Flex column separation="24px" xAlign="center">
      <Input
        placeholder="Username"
        {...usernameHook.bind}
        onKeyDown={runOnEnter(createUser)}
        tabIndex={0}
      />
      <Input
        placeholder="First Name"
        {...firstNameHook.bind}
        onKeyDown={runOnEnter(createUser)}
        tabIndex={0}
      />
      <Input
        placeholder="Last Name"
        {...lastNameHook.bind}
        onKeyDown={runOnEnter(createUser)}
        tabIndex={0}
      />
      <SelectUsingButton
        selection={permissionLevel}
        options={permissionLevelOptions}
        onChange={({ newIndex }) => setPermissionLevel(permissionLevelOptions[newIndex].value)}
      />
      {errorText && <ErrorText>{errorText}</ErrorText>}
      {successText && <SuccessText>{successText}</SuccessText>}
      <Button onClick={createUser}>Create User</Button>
    </Flex>
  )
}
